import { create } from "zustand";
import { MealTypePriceList } from "@/lib/Types/DateListResponse/MealTypePriceList";

interface DateListStore {
  priceList: MealTypePriceList[] | null;
  hotelAlreadyBooked: boolean | null;
  setPriceList: (priceList: MealTypePriceList[] | null) => void;
  reset: () => void;
}

export const useDateListStore = create<DateListStore>((set) => ({
  priceList: null,
  hotelAlreadyBooked: null,
  setPriceList: (priceList) => set({ priceList }),
  reset: () => set({ priceList: null, hotelAlreadyBooked: null }),
}));
